import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { Tooltip } from "@heroui/react";
import { isNavItemActive } from "@/shared/utils/navigationConfig";
import LogoutConfirm from "../../ui/Logout/LogoutConfirm";

const SidebarItem = ({ navLink, expanded, badge, disabled }) => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = isNavItemActive(pathname, navLink);
  const IconComponent = navLink.iconType;
  const displayBadge = badge ?? navLink?.badge;

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const handleClick = () => {
    if (navLink.action) {
      handleLogout();
    } else if (!disabled) {
      navigate(navLink.url);
    }
  };

  const itemContent = (
    <div
      onClick={handleClick}
      className={`group relative flex items-center h-10 rounded-xl cursor-pointer select-none transition-all duration-150 ${
        expanded
          ? "w-full px-3.5 gap-3.5"
          : "w-10 h-10 justify-center mx-auto"
      } ${
        disabled
          ? "opacity-50 cursor-not-allowed"
          : isActive
          ? "bg-secondary/15 text-secondary dark:text-secondary-light font-semibold"
          : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-100 font-medium"
      }`}
    >
      <div className="relative flex items-center justify-center shrink-0">
        {navLink?.image ? (
          <img
            src={navLink?.iconType}
            alt={navLink?.title}
            className={`w-[19px] h-[19px] transition-colors ${
              isActive ? "text-secondary" : "text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-100"
            }`}
          />
        ) : (
          <IconComponent
            size={19}
            className={`transition-colors ${
              isActive ? "text-secondary" : "text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-100"
            }`}
          />
        )}
        {!expanded && displayBadge != null && displayBadge > 0 && (
          <span className="absolute -top-1 -right-1 flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary"></span>
          </span>
        )}
      </div>

      {expanded && (
        <div className="flex items-center justify-between min-w-0 flex-1 gap-2">
          <span className="truncate text-[0.84rem] tracking-tight">
            {navLink.title}
          </span>
          {disabled ? (
            <span className="shrink-0 text-[9px] font-medium text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded-md">
              Soon
            </span>
          ) : displayBadge != null && displayBadge > 0 ? (
            <span className="shrink-0 min-w-[20px] h-[20px] flex items-center justify-center rounded-md bg-gray-100 text-gray-700 font-medium text-xs px-1.5">
              {displayBadge > 99 ? "99+" : displayBadge}
            </span>
          ) : null}
        </div>
      )}
    </div>
  );

  return (
    <>
      {!expanded ? (
        <Tooltip
          content={navLink.title}
          placement="right"
          offset={12}
          className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 font-medium text-xs shadow-md border border-gray-100 dark:border-gray-700 px-3 py-1.5 rounded-lg"
        >
          {itemContent}
        </Tooltip>
      ) : (
        itemContent
      )}
      {showLogoutConfirm && (
        <LogoutConfirm
          showLogoutConfirm={showLogoutConfirm}
          onClose={() => setShowLogoutConfirm(false)}
        />
      )}
    </>
  );
};

export default SidebarItem;
